/* eslint-disable no-useless-escape */
const REGEXS = {
  name: /^[A-Za-z ]*$/,
  email: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  mobile: /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#^`~$!%*?&])[A-Za-z\d@#^`~$!%*?&]{8,20}$/,
  pincode: /^[1-9]{1}[0-9]{5}$/,
  religion: /^[A-Za-z ]*$/,
  number: /^[0-9]*$/,
  alplabhets: /^[A-Za-z ]*$/,
  alplabhetNumeric: /^[A-Za-z0-9 ]*$/,
  alplabhetNumericWithSpecial: /^[ A-Za-z0-9_@./'"#&(),+-]*$/,
  idProofRegex: {
    1: /^[2-9][0-9]{11,11}$/,
    2: /^[A-Za-z]{3}\d{7}$/,
    3: /^[A-PR-WYa-pr-wy][1-9]\d\s?\d{4}[1-9]$/,
    4: /^(([A-Za-z]{2}[0-9]{2})( )|([A-Za-z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/,
    5: /[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}/,
  },
  address: /^[A-Za-z0-9 ,./-]+$/,
  url: /^(https?:\/\/)(?!.*<script>)(?!.*\s)(?!^[^a-zA-Z]*$)[\w\-./?%&=+#@!,:;]*$/,
}

export default REGEXS;